import { render } from "./Dropdown.vue?vue&type=template&id=8e2aac9e"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"
script.render = render

export default script